<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs6 sm6 md6>
        <v-layout justify-center>
          <v-card class="elevation-12" width="600" ref="form">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Sign Up</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-form v-if="error" class="red--text">{{error}}</v-form>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field ref="firstname" label="First Name" type="email" single-line class="mr-3 ml-10" v-model="firstname" :rules="[rules.required]"></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field ref="lastname" label="Last Name" type="email" single-line class="mr-3 ml-10" v-model="lastname" :rules="[rules.required]"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
              <v-form>
                <v-text-field ref="email" label="Email" prepend-icon="mdi-email" type="email" single-line v-model="email" :rules="[rules.required, rules.email]" :error="error !== '' && error.includes('email')"></v-text-field>
                <v-text-field ref="password" label="Password" prepend-icon="mdi-lock" :type="showPass ? 'text' : 'password'" :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPass = !showPass" v-model="password" :rules="[rules.required, rules.password]"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="register" color="primary">Sign Up</v-btn>
            </v-card-actions>
          </v-card>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      showPass: false,
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      error: '',
      formHasErrors: false,
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Must be a valid e-mail.'
        },
        password: v => v.length > 5 || 'Password must be greater than 5 characters'
      }
    }
  },
  computed: {

    ...mapState(['user']),
    form () {
      return {
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        password: this.password
      }
    }
  },
  created () {

  },

  mounted () {
  },
  methods: {
    navigateResetPassword () {
      console.log('hello')
      this.$router.push({ name: 'ResetPassword' })
    },
    register () {
      // var self = this
      this.formHasErrors = false
      this.error = ''
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true
        if (!this.$refs[f].validate(true)) this.formHasErrors = true
      })
      if (this.formHasErrors === false) {
        this.$firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(user => {
          this.$store.dispatch('users/set', { firstName: this.firstname, lastName: this.lastname })
          this.$firebase.auth().currentUser.updateProfile({
            displayName: this.firstname + ' ' + this.lastname
          })
          this.$router.push({ name: 'Home' })
        }).catch(err => {
          this.error = err.message
        })
      }
    },
    temp () {

    }

  }
}
</script>

<style scoped>
.pointer {cursor: pointer;}
</style>
